export * from './loader'
export type { ComponentRegistry } from './types/component-registry.type'
